<template>
  <v-app>
    <v-container class="hero">
      <div class="d-flex flex-column fill-height justify-center align-center">
        <v-sheet
          max-width="500"
          width="95%"
          min-width="250"
          min-height="250"
          elevation="10"
          class="d-flex flex-column justify-center align-center"
          color="white"
        >
          <h1><v-icon style="vertical-align: baseline; font-size: 4rem">mdi-close-circle-outline</v-icon> 404</h1>
          <v-divider thickness="0"></v-divider>
          <h4>PAGE NOT FOUND</h4>
          <!-- <v-divider thickness="0"></v-divider>
          <slot /> -->
        </v-sheet>
      </div>

      <snackbar :show="show"></snackbar>
    </v-container>
  </v-app>
</template>

<script setup>
useHead({
  meta: [{ name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' }]
})
import snackbar from '@/layouts/imports/snackbar'
import { useTheme } from 'vuetify'

const theme = useTheme()
const pimTheme = useCookie('pim_theme')

useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} - N41 PIM` : 'N41 PIM'
  }
})

const { show } = useSnackbarStore()

// data

// method
theme.global.name.value = pimTheme.value || 'light'
</script>
<style scoped>
.hero {
  background: url('/bg_404.jpg');
  background-blend-mode: luminosity;
  background-color: rgba(255, 255, 255, 1);
  background-size: cover;
  height: 100vh;
  width: 100vw;
  max-width: 100vw;
  padding: 0;
  margin: 0;
}
h1 {
  font-size: 4rem;
}
h4 {
  font-size: 1rem;
}
</style>
